/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkAlcoGlassCocktailIcon16Light } from './FoodDrinkAlcoGlassCocktailIcon16Light';
import { FoodDrinkAlcoGlassCocktailIcon16Regular } from './FoodDrinkAlcoGlassCocktailIcon16Regular';
import { FoodDrinkAlcoGlassCocktailIcon16Solid } from './FoodDrinkAlcoGlassCocktailIcon16Solid';
import { FoodDrinkAlcoGlassCocktailIcon20Light } from './FoodDrinkAlcoGlassCocktailIcon20Light';
import { FoodDrinkAlcoGlassCocktailIcon20Regular } from './FoodDrinkAlcoGlassCocktailIcon20Regular';
import { FoodDrinkAlcoGlassCocktailIcon20Solid } from './FoodDrinkAlcoGlassCocktailIcon20Solid';
import { FoodDrinkAlcoGlassCocktailIcon24Regular } from './FoodDrinkAlcoGlassCocktailIcon24Regular';
import { FoodDrinkAlcoGlassCocktailIcon24Solid } from './FoodDrinkAlcoGlassCocktailIcon24Solid';
import { FoodDrinkAlcoGlassCocktailIcon32Regular } from './FoodDrinkAlcoGlassCocktailIcon32Regular';
import { FoodDrinkAlcoGlassCocktailIcon64Regular } from './FoodDrinkAlcoGlassCocktailIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkAlcoGlassCocktailIcon16Light,
        regular: FoodDrinkAlcoGlassCocktailIcon16Regular,
        solid: FoodDrinkAlcoGlassCocktailIcon16Solid,
    },
    20: {
        light: FoodDrinkAlcoGlassCocktailIcon20Light,
        regular: FoodDrinkAlcoGlassCocktailIcon20Regular,
        solid: FoodDrinkAlcoGlassCocktailIcon20Solid,
    },
    24: {
        regular: FoodDrinkAlcoGlassCocktailIcon24Regular,
        solid: FoodDrinkAlcoGlassCocktailIcon24Solid,
    },
    32: {
        regular: FoodDrinkAlcoGlassCocktailIcon32Regular,
    },
    64: {
        regular: FoodDrinkAlcoGlassCocktailIcon64Regular,
    },
};
export var FoodDrinkAlcoGlassCocktailIcon = forwardRef('FoodDrinkAlcoGlassCocktailIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
